export default __webpack_public_path__ + "static/10-fir-19dd398121819ee1df927f9841d0d028.png";